<template>
  <Dialog :common-dialog="productDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout>
        <v-flex>
          <span class="text-capitalize">Select
            <template v-if="productType == 'tools'"> Tools</template>
            <template v-else-if="productType == 'equipment'">
              Customer Asset</template>
            <template v-else-if="productType == 'goods'"> Products</template>
            <template v-else> {{ productType }}</template></span>
          ({{ getSelectedItem }})
          <!--  <v-icon class="mx-2 color-custom-blue" small>mdi-record</v-icon>
          Line Item -->
        </v-flex>
        <v-flex class="text-right">
          <v-btn style="height: 32px !important" class="custom-bold-button mr-2" depressed :disabled="vStateLoading"
            color="cyan white--text" v-on:click="save_line_item()">Save</v-btn>
          <v-btn style="height: 32px !important" class="custom-bold-button" depressed :disabled="vStateLoading"
            v-on:click="$emit('close', true)">Close</v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div>
        <div v-if="vLineItemAlpha && vLineItemAlpha.length" class="d-flex mb-2" style="overflow-x: scroll">
          <!--  <div
            style="position: relative"
            v-for="(alpha, index) in vLineItemAlpha"
            :key="`alphabet-${index}`"
            :class="{ 'alpha-exist': alpha.exist }"
            class="alph-listing custom-border-right"
          >
            <v-btn
              color="cyan white--text custom-bold-button"
              depressed
              tile
              :disabled="vStateLoading"
              :text="alphabet == alpha.value"
              v-on:click="filter_alpha(alpha.value)"
            >
              {{ alpha.label }}
            </v-btn>
            <v-icon v-if="alpha.exist" color="red">mdi-record</v-icon>
          </div> -->
        </div>
        <div v-if="vLineItemCategory && vLineItemCategory.length && false" class="d-flex mb-2"
          style="overflow-x: scroll">
          <div style="position: relative" v-for="(cat, index) in vLineItemCategory" :key="`category-${index}`"
            class="custom-border-right">
            <v-btn color="cyan white--text custom-bold-button" depressed tile :disabled="vStateLoading"
              :text="category == cat.value" v-on:click="filter_cat(cat.value)">
              {{ cat.label }}
            </v-btn>
          </div>
        </div>
        <div class="d-flex mb-2">
          <v-text-field v-model="search" class="line-item-header-text px-0 v-slot-m-none" placeholder="Search..." dense
            filled solo :disabled="vStateLoading" clearable flat color="cyan" style="max-width: 400px" />
          <v-btn style="height: 32px !important" class="custom-bold-button ml-2" depressed :disabled="vStateLoading"
            v-on:click="find_items()" color="cyan white--text">Search</v-btn>
          <v-autocomplete hide-details v-model.trim="filter_categoty" :items="vLineItemCategory" clearable
            v-on:click:clear="filter_categoty = null" style="max-width: 250px !important" dense flat filled
            placeholder="Category" item-color="cyan" class="ml-2 mr-1 custom-boder-color" color="cyan" solo
            v-on:change="filter_cat($event)" item-value="value" item-text="label">
          </v-autocomplete>
          <v-autocomplete hide-details v-model.trim="filter_house_type" v-if="productType == 'service'"
            :items="vLineItemHouseType" clearable v-on:click:clear="filter_house_type = null"
            style="max-width: 250px !important" dense flat filled placeholder="House type" item-color="cyan"
            class="ml-2 mr-1 custom-boder-color" color="cyan" solo v-on:change="filter_cat($event, 'house_type')"
            item-value="value" item-text="value">
          </v-autocomplete>
        </div>
        <div>
          <div class="d-flex grey lighten-4">
            <div class="font-weight-600 py-2 text-center d-flex justify-center" style="width: 5%">
              <v-checkbox v-on:change="update_all_line_item($event)" hide-details :disabled="vStateLoading"
                class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" />
            </div>
            <!-- Product Type / Tools / Products -->
            <div class="color-custom-blue py-2 font-weight-700 text-capitalize" :style="{
              width:
                productType === 'goods' || productType === 'parts'
                  ? '35%'
                  : '45%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }">
              <template v-if="productType === 'tools'">Tools</template>
              <template v-else-if="productType === 'goods'">Products</template>
              <template v-else>{{ productType }}</template>
            </div>

            <!-- Available Quantity -->
            <div v-if="productType === 'goods' || productType === 'parts'"
              class="color-custom-blue py-2 font-weight-700" style="
                width: 20%;
                display: flex;
                justify-content: center;
                align-items: center;
              ">
              Available Quantity
            </div>

            <!-- <div
              v-if="productType == 'equipment'"
              class="color-custom-blue py-2 font-weight-700 text-left"
              style="width: 20%"
            >
              Sub-Location
            </div> -->
            <!-- Selling/Unit Cost -->
            <div class="color-custom-blue py-2 font-weight-700" v-if="productType != 'tools'" :style="{
              width:
                productType === 'goods' || productType === 'parts'
                  ? '20%'
                  : '25%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }">
              Selling/Unit Cost
            </div>

            <!-- UOM -->
            <!-- <div class="color-custom-blue py-2 font-weight-700" style="
                width: 10%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              UOM
            </div> -->

            <div class="color-custom-blue py-2 font-weight-700" v-if="productType != 'tools'" :style="{
              width:
                productType === 'goods' || productType === 'parts'
                  ? '20%'
                  : '25%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }">
              Quantity
            </div>
          </div>
          <div style="overflow-y: scroll; max-height: calc(100vh - 360px)">
            <div v-if="vStateLoading" class="my-4 py-4">
              <v-progress-linear color="cyan" indeterminate rounded height="6"></v-progress-linear>
            </div>
            <div v-else-if="vLineItem && vLineItem.length">
              <div v-for="(row, index) in vLineItem" :key="index" class="d-flex pt-1 custom_row"
                :class="getDisabled(row) ? 'eqp-opacity' : ''">
                <div class="font-weight-600 text-center d-flex justify-center" style="width: 5%">
                  <v-checkbox v-model="row.status" :disabled="getDisabled(row)" hide-details
                    class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" />
                </div>
                <div class="text-left" :style="productType == 'tools' || productType == 'parts'
                  ? 'width: 90%'
                  : ' width: 45%'
                  ">
                  <div class="d-flex">
                    <div>
                      <v-avatar size="32">
                        <img v-if="row?.image?.url" :src="row?.image?.url" :alt="row?.image?.name" />
                        <img v-else :src="$defaultImage" />
                      </v-avatar>
                      <div v-if="row.has_property" class="font-weight-600 d-flex align-center mb-1">
                        <template v-if="
                            /* productType == 'equipment' &&  */ row &&
                          row.barcode
                        ">
                          <v-chip label color="chip-custom-blue" outlined x-small class="text-white px-1 mt-1"
                            style="font-weight: 700">{{ row.barcode }}</v-chip>
                        </template>
                      </div>
                    </div>
                    <div style="width: 100%" class="ml-0">
                      <v-text-field v-model="row.product" class="line-item-header-text px-0" :placeholder="productType"
                        dense filled solo flat color="cyan" :disabled="getDisabled(row)" />
                      <v-textarea v-if="false" class="px-0" v-model="row.description" placeholder="Description" dense
                        filled solo flat rows="2" auto-grow color="cyan" :disabled="getDisabled(row)" />

                      <!--   <v-checkbox
                           v-if="row.type == 'product'"
                          inset
                          color="cyan"
                          label="As Equipment"
                          dense
                          class="pt-0 mt-2"
                          v-model="row.is_equipment"
                          hide-details
                          :false-value="0"
                          :true-value="1"
                        >
                      </v-checkbox>  -->
                      <div v-if="row.has_property" class="font-weight-600 d-flex align-center">
                        <!-- <template
                          v-if="
                            productType == 'equipment' && row && row.serial_no
                          "
                        >
                          <v-chip
                            label
                            color="chip-custom-blue"
                            outlined
                            class="text-white p-3 mr-2"
                            style="font-weight: 700; margin-top: -6px"
                            >{{ row.serial_no }}</v-chip
                          >
                        </template> -->
                        <!--  <template v-if="row?.property?.parent?.name">
                          <v-chip small>{{ row.property.parent.name }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.child?.name">
                          <v-chip small style="padding: 12px !important">{{
                            row.property.child.name
                          }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.type == 'child-child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'parent-'">
                          <v-chip
                            small
                            style="padding: 12px !important"
                            v-if="row?.property?.property_name"
                          >
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template> -->
                        <template v-if="
                          productType != 'goods' &&
                          row &&
                          row.has_warranty &&
                          row.has_warranty > 0
                        ">
                          <v-chip :color="getWarrantyStatusColor(row.warranty_status)" small text-color="white"
                            class="ml-2">
                            Warranty
                          </v-chip>
                        </template>
                        <template v-if="
                          (productType == 'equipment' ||
                            productType == 'tools') &&
                          row &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          showModules.preventive_maintanance
                        ">
                          <v-chip :color="row?.is_consumed ? 'red' : 'lightgray'" class="ml-2" small text-color=""
                            outlined v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                              ">
                            {{ row.preventive_barcode }}
                          </v-chip>
                        </template>
                        <template v-if="
                          productType == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          showModules.location
                        ">
                          <v-chip :color="row?.is_consumed ? 'red' : 'lightgray'" class="ml-2" small text-color=""
                            outlined v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                              ">
                            {{ row.location }}
                          </v-chip>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="productType == 'goods' || productType == 'parts'" class="text-center" style="width: 20%">
                  <v-text-field class="line-item-header-text px-0" placeholder="Available Quantity" dense filled solo
                    type="number" v-model="row.initial_stock" flat :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.initial_stock)" color="cyan" :readonly="productType == 'parts' ||
                      productType == 'tools' ||
                      productType == 'goods'
                      " />
                </div>
                <!-- <div
                  class="text-center"
                  style="width: 20%"
                  v-if="productType == 'equipment'"
                >
                  <v-autocomplete
                    class="line-item-header-text px-0"
                    placeholder="Sub-Location"
                    :items="subLocationList"
                    dense
                    filled
                    solo
                    type="text"
                    v-model="row.location"
                    flat
                    :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.location)"
                    color="cyan"
                  />
                </div> -->
                <div class="text-center" v-if="productType != 'tools'" :style="productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
                  ">
                  <v-text-field class="line-item-header-text px-0" placeholder="Selling/Unit Cost" dense filled solo
                    type="number" v-model="row.rate" flat :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.rate)" color="cyan" />
                </div>
                <!-- <div>
                  <v-autocomplete dense filled color="cyan" item-color="cyan" :items="vLineItemUnit" placeholder="UOM"
                    solo flat item-text="text" item-value="text" class="pr-0 width-33" v-model.trim="row.unit">
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No UOM Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div> -->
                <div class="text-center" v-if="productType != 'tools'" :style="productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
                  ">
                  <v-text-field :readonly="productType == 'equipment'" class=" line-item-header-text px-0"
                    placeholder="Quantity" dense filled type="number" v-model="row.quantity"
                    :disabled="getDisabled(row)" solo flat v-on:keyup="checkAvailableQuantity(row)"
                    v-on:keypress="isNumber($event)" color="cyan" />
                </div>
              </div>
            </div>
            <div v-else>
              <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no item at the moment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { GET_LINE_ITEM, SET_LOADING } from "@/core/services/store/visit.module";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "line-item-dialog-v2",
  props: {
    productType: {
      type: String,
      default: null,
    },
    productDialog: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: Number,
      default: 0,
    },
    unitList: {
      type: Array,
      default: () => [],
    },
    isType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      search: null,
      category: "all",
      house_type: "all",
      alphabet: "all",

      filter_categoty: null,
      filter_house_type: null,
    };
  },
  components: {
    Dialog,
  },
  methods: {
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    checkAvailableQuantity(row) {
      if (row.product_type == "goods" || row.product_type == "parts") {
        if (Number(row.quantity) > Number(row.initial_stock)) {
          ErrorEventBus.$emit(
            "update:error",
            "Quantity exceeds available quantity"
          );
          return (row.quantity = row.initial_stock);
        }
      }
    },
    getDisabled(row) {
      if (
        this.moduleType &&
        this.moduleType == 3 &&
        row?.preventive_id > 0 &&
        row?.item_count > 0
      ) {
        return true;
      }
      return false;
    },
    find_items() {
      let productType = this.productType;
      if (productType == "product") {
        productType = "goods";
      }
      // Inside your component
      let job_type = this.$route?.query?.type;
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(GET_LINE_ITEM, {
          type: productType,
          search: this.search,
          category: this.category,
          house_type: this.house_type,
          alphabet: this.alphabet,
          customer: productType != "tools" ? this.vCustomerId : 0,
          start_date: this.prventiveRecurringSchedule?.start_date || null,
          end_date: this.prventiveRecurringSchedule?.dbEndDate || null,
          is_recurring: job_type == null
            ? null
            : job_type == 'one-off'
              ? '0'
              : job_type == 'recurring'
                ? '1'
                : null
        })
        .then((output) => {
          console.log({ output });
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.$store.dispatch(SET_LOADING, false);
        });
    },
    save_line_item() {
      let selected_line_items = [];

      let status = false;
      for (let item of this.vLineItem) {
        if (item.status) {
          status = true;
          selected_line_items.push(item);
        }
      }
      let error = true;

      if (selected_line_items?.length > 0 && this.isType == 7) {
        for (let item of selected_line_items) {
          this.vSelectedLineItem.forEach((row) => {
            if (row.barcode == item.barcode) {
              ErrorEventBus.$emit(
                "update:error",
                `${item.barcode} already used `
              );
              error = false;
              return false;
            }
          });
        }
      }
      if (!error && this.isType == 7) {
        return false;
      }
      if (!status) {
        ErrorEventBus.$emit("update:error", `Please select Item.`);
        return false;
      }
      this.$emit("update-values", selected_line_items);
      this.$emit("close", true);
    },
    update_all_line_item(status) {
      if (this.moduleType == 7) {
        for (let i = 0; i < this.vLineItem.length; i++) {
          if (
            /* this.vLineItem[i].preventive_id == 0 &&  */ this.vLineItem[i]
              .item_count == 0
          ) {
            this.vLineItem[i].status = status;
          }
        }
      } else {
        for (let i = 0; i < this.vLineItem.length; i++) {
          this.vLineItem[i].status = status;
        }
      }
    },
    filter_cat(param, filter_type = null) {
      if (filter_type === "house_type") {
        this.house_type = param;
      } else {
        this.category = param;
      }
      this.find_items();
    },
    filter_alpha(param) {
      this.alphabet = param;
      this.find_items();
    },
  },
  mounted() {
    if (this.productDialog) {
      this.find_items();
    }
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vLineItem",
      "vLineItemAlpha",
      "vStateLoading",
      "vLineItemCategory",
      "vLineItemHouseType",
      "vLineItemUnit",
      "vSelectedLineItem",
      "prventiveRecurringSchedule",
    ]),
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 80);
    },
    getSelectedItem() {
      return this.vLineItem.filter((item) => item.status).length;
    },
  },
};
</script>
<style scoped>
.custom_row {
  border-bottom: 1.5px solid #dbd7d7;
}

.custom_row:nth-child(even) {
  background: #fff4de;
}

.custom_row:hover {
  background: #fff4de;
}
</style>
